/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.LabelDepartmentInfoResponseDto>>;
export function request(
  body: defs.basics.LabelDepartmentInfoRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/core/labelDepartmentInfo/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
